module.exports = __webpack_public_path__ + "img/rda2.3aa9c4aa.gif";